import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UrlMatcher } from '../url-matcher/url-matcher';
import { ResolverType } from '../url-matcher/resolver-types.enum';
import { DOCUMENT } from '@angular/common';

export interface UrlHandlerReturn {
    handleUrl: (url: string) => void;
    navigateByType: (type: ResolverType, params?: Record<string, any>) => void;
}

@Injectable({
    providedIn: 'root'
})
export class UrlHandlerService implements UrlHandlerReturn {
    private urlMatcher: UrlMatcher = new UrlMatcher();

    public constructor(private router: Router, @Inject(DOCUMENT) private document: Document) {}

    public handleUrl(url: string): void {
        const result: { type: ResolverType; params: Record<string, any> } = this.urlMatcher.match(url);
        this.navigateByType(result.type, result.params);
    }

    public navigateByType(type: ResolverType, params: Record<string, any> = {}): void {
        switch (type) {
            case ResolverType.TRANSACTION_INSTRUCTIONS:
                this.document.location.href = `/t/transactions/v3/${params.transactionId}/${params.transactionKey}/${params.transactionMid}/instructions`;
                break;
            case ResolverType.TRANSACTION_SCREENSHOT:
                this.document.location.href = `/t/transactions/v3/${params.transactionId}/${params.transactionKey}/${params.transactionMid}/screenshot`;
                break;
            case ResolverType.TRANSACTION_STATES:
                this.document.location.href = `/t/transactions/v3/${params.transactionId}/${params.transactionKey}/${params.transactionMid}/states`;
                break;
            case ResolverType.DASHBOARD_TRANSACTION_INSTRUCTIONS:
                this.router.navigate(['/my/dashboard/transactions/v3/' + params.transactionId + '/instructions']);
                break;
            case ResolverType.DASHBOARD_TRANSACTION_STATES:
                this.router.navigate([`/my/dashboard/transactions/v3/${params.transactionId}/states`]);
                break;
            case ResolverType.DASHBOARD_TRANSACTION_SCREENSHOT:
                this.router.navigate([`/my/dashboard/transactions/v3/${params.transactionId}/screenshot`]);
                break;
            case ResolverType.DASHBOARD_VALIDATIONS:
                this.router.navigate([`/my/dashboard/validations/${params.validationTypeId}`]);
                break;
            case ResolverType.DASHBOARD_HELP_CENTER:
                this.router.navigate(['/my/dashboard/private-help-center']);
                break;
            case ResolverType.USER_VALIDATION:
                this.document.location.href = `/u/users/${params.userId}/${params.userKey}/${params.validationTypeId}`;
                break;
            case ResolverType.HELP:
                this.document.location.href = `/help`;
                break;
            case ResolverType.WEBVIEW:
            default:
                if (params.url) {
                    window.open(params.url, '_blank');
                }
                break;
        }
    }
}
